import { useContext } from "react";
import { WalletContext } from "../components/shared-wallet-context";
import { WalletAdapterStatus } from "../utils/types";

export function useWalletConnection() {
  // Get wallet context
  const wallet = useContext(WalletContext);

  if (!wallet) {
    throw new Error("useWalletConnection must be used within a WalletProvider");
  }

  const isConnected = wallet.status === WalletAdapterStatus.CONNECTED && !!wallet.selectedAccount;
  const isConnecting = wallet.status === WalletAdapterStatus.CONNECTING;

  const { status, selectedAccount, connect, disconnect, sendTransaction } = wallet;

  return {
    // Connection State
    isConnected,
    isConnecting,
    status,
    selectedAccount,

    // Connection Actions
    connect,
    disconnect,

    // Transaction Functions
    sendTransaction,
  };
}
